/**
 * NetworkUserEvents
 * Registry of events for the Network pages
 */
export enum NetworkUserEvents {
    TableLinkClick = "Network Table - Click Individual Page Link",
    LeagueTableClickAssetClass = "Network League Table - Click Asset Class",
    ClickNetworkIndividualWebsite = "Network Individual Header - Click Website",
    ClickNetworkServiceProviderWebsite = "Network Service Provider Card - Click Website",
    ClickNetworkPieChartToggleStablecoins = "Network Pie Chart - Click Toggle Stablecoins",
    ClickParentNetworkLink = "Network Individual Header - Click Parent Network",
}
